import CharFilter from "componentsv2/experimental/fieldsFilter/CharFilter";
import Many2oneFilter from "componentsv2/experimental/fieldsFilter/Many2oneFilter";
import SelectionFilter from "componentsv2/experimental/fieldsFilter/SelectionFilter";
import DateFilter from "componentsv2/experimental/fieldsFilter/DateFilter";
import Date2Filter from "componentsv2/experimental/fieldsFilter/Date2Filter";
import One2manyFilter from "componentsv2/experimental/fieldsFilter/One2ManyFilter";

const poolFilter = () => ({
  char: CharFilter,
  many2one: Many2oneFilter,
  selection: SelectionFilter,
  date: DateFilter,
  date_2: Date2Filter,
  one2many: One2manyFilter,
});

export default poolFilter;
